import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { RBAC_PERMISSIONS } from '@/constants/permissions';
import { z } from 'zod';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { UserViewPage } from '@/features/users/pages/UserViewPage';

const searchSchema = z.object({
  userId: z.number(),
  from: z.string().optional(),
});

export const Route = createFileRoute('/_auth/users/view')({
  beforeLoad: () => requirePermission(RBAC_PERMISSIONS.USER_ALL_VIEW),
  validateSearch: searchSchema,
  component: function UserViewRoute() {
    const { userId, from } = Route.useSearch();
    return (
      <ErrorBoundary moduleName="User Profile">
        <UserViewPage userId={userId} fallbackPath={from} />
      </ErrorBoundary>
    );
  },
});
